import React, { useRef } from "react"

import VirtualGrid from "./VirtualGrid"

const VirtualGridWrapper = (props) => {
  const {
    data,
    title,
    sectionId,
    containerRef,
    keyField,
    offset = 2,
    renderItem,
    breakPoints,
    sectionTitle,
    sectionHeight,
    sameHeightAndWidth,
    listEmptyComponent = null
  } = props

  const ref = useRef(null)

  return (
    <div
      ref={ref}
      id={sectionId}
      style={{ height: `${sectionHeight}px` }}
    >

      {sectionTitle(title)}

      <VirtualGrid
        data={data}
        sectionId={sectionId}
        keyField={keyField}
        offset={offset}
        renderItem={renderItem}
        containerRef={containerRef}
        breakPoints={breakPoints}
        sameHeightAndWidth={sameHeightAndWidth}
        listEmptyComponent={listEmptyComponent}
      />
    </div>
  )
}

export default React.memo(VirtualGridWrapper)